<template>
  <v-row >
    <!-- SLOT PARA CAMPOS COMPLEMENTARES AO FORMULÀRIO -->
    <v-col>
      <slot name="header"></slot>
    </v-col>

    <v-col v-for="(input, index) in form" :key="input.name" :cols="12">
      
      <SGPFormSelectComponent
        v-if="typeof input.type == 'undefined' || input.type == 'select' || input.type == 'unico'"
        :name="`${input.name}`"
        v-model="input.value"
        :placeholder="`${input.titulo}`"
        :optionSelecione="'Todos'"
        :listaDeOptions="opcoesAtuais(input)"
        :class="(typeof input.class != 'undefined')? input.class : ''"
        optionValue="value"
        optionLabel="text"
        @change="aoMudarSelect($event, input, index)"
      />

      <SGPFormAutocompleteComponent
        v-else-if="input.type == 'auto_complete'"
          v-model="input.value"
          :listaDeOptions="opcoesAtuais(input)"
          optionValue="value"
          optionLabel="text"
          :placeholder="input.titulo"
          :selecaoMultipla="input.selecaoMultipla"
          @change="changeFiltrar(input, index)"
          @selecionaTodos="changeFiltrar(input, index)"
        />
        
      <SGPFormInputComponent 
        v-else-if="input.type == 'text'"
          v-model="input.value"
          :name="input.name"
          :data-vv-as="input.titulo"
          :placeholder="input.titulo"
      />

      <SGPFormToggleComponent
        v-else-if="input.type == 'toggle'"
        :name="input.name"
        :titulo="input.titulo"
        :value="Boolean(input.value)"
        @input="input.value = Boolean($event)"
      />

      <SGPFormMesComponent
        v-else-if="input.type == 'mes'"
        :name="input.name"
        v-model="input.value"
        :placeholder="input.titulo"
      />

      <SGPFormDataComponent
        v-else-if="input.type == 'date'"
        :name="`${input.name}`"
        v-model="input.value"
        :placeholder="`${input.titulo}`"
        :time="input.time"
        @change="changeDate()"
      />

      <SGPFormSelectComponent
        v-else-if="input.type == 'multiplo'"
        :name="`${input.name}`"
        selecaoMultipla
        v-model="input.value"
        :placeholder="`${input.titulo}`"
        :optionSelecione="'Todos'"
        :listaDeOptions="opcoesAtuais(input)"
        optionValue="value"
        optionLabel="text"
        @change="changeFiltrar(input, index)"
      />
    </v-col>

    <!-- SLOT PARA CAMPOS COMPLEMENTARES AO FORMULÀRIO -->
    <v-col>
      <slot></slot>
    </v-col>

    <v-col cols="12">
      <!-- <b-button v-if="download" variant="primary" class="mb-2 w-100" @click="clickDownload">{{ labelDownload }}</b-button> -->
      <SGPFormBotaoComponent v-if="download" rounded  @click="clickFiltrar" class="mr-1">{{ labelDownload }}</SGPFormBotaoComponent>
      <SGPFormBotaoComponent v-else rounded  @click="clickFiltrar" class="mr-1">Filtrar</SGPFormBotaoComponent>
      <SGPFormBotaoComponent rounded color="grey-5" @click="limparCampos()">Limpar</SGPFormBotaoComponent>
    </v-col>        
  </v-row>
</template>

<script>
export default {
  name: 'SGPFormFilterComponent',

  props: {
    campos: {
      type: Array,
      required: true
    },
    filtrar: {
      type: Boolean,
      required: false,
      default: true,
    },
    download: {
      type: Boolean,
      required: false,
      default: false,
    },
    labelDownload: {
      type: String,
      required: false,
      default: 'Download',
    },
  },

  data () {
    return {
      form: [ ...this.campos ]
    }
  },

  methods: {
    clickFiltrar () {
      this.$emit('sgpFormFilterDadosClick', this.form)
    },

    clickDownload () {
      this.$emit('sgpFormFilterDadosDownload', this.form)
    },

    changeDate () {
      this.$emit('sgpFormFilterDadosChange', this.form)
    },

    opcoesAtuais (input) {
      const atual = (this.campos || []).find(campo => campo.name === input.name)
      if (atual && Array.isArray(atual.options)) return atual.options
      return input.options || []
    },

    aoMudarSelect (valor, input, index) {
      this.$set(this.form[index], 'value', valor)
      this.changeFiltrar(this.form[index], index)
    },

    changeFiltrar (input, index) {
      this.form[index].valueLabel = this.getValueLabel(input)
      this.$emit('sgpFormFilterDadosChange', this.form)
    },

    getValueLabel (input) {
      if (!input.value) return ''
      const labelText = input.options.filter(option => option.value === input.value)[0]
      if (labelText) return labelText.text
    },

    limparCampos () {
      console.log('Limpar Filtros')
      this.form.forEach(input => {
        if(input.type === 'multiplo') {
          input.value = []
          return
        }
        input.value = ''
      })

      if (localStorage.filtroAvancado) {
        localStorage.removeItem('filtroAvancado')
      }
      
      this.$emit('sgpFormFilterLimpar')
    },
  },

  watch: {
    campos(novos) {
      (novos || []).forEach((campo, index) => {
        if (this.form.some(item => item.name === campo.name)) return
        this.form.splice(index, 0, { ...campo })
      })
    },
  },
}
</script>
